var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PieChart_1;
import React from 'react';
import { Cell, Pie, PieChart as RechartsPieChart, ResponsiveContainer } from 'recharts';
import { Unit } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { arrayOf, bool, color, number, object, predefinedSize, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { resolveHSLColor } from '@philips-internal/oswald-ui-utils';
import { ChartClickType, ChartType } from '../base-chart/base-chart-constants.js';
import { fitPredefinedSizeValue } from '../base-chart/base-chart-utils.js';
import { BaseChart } from '../base-chart/base-chart.js';
import { PieChartAPI } from './pie-chart-api.js';
import { PIE_DEFAULT_CX_VALUE, PIE_DEFAULT_CY_VALUE, PIE_PIECE_DEFAULT_COLOR } from './pie-chart-constants.js';
let PieChart = PieChart_1 = class PieChart extends BaseChart {
    constructor() {
        super(...arguments);
        this.state = {
            ...BaseChart.defaultState,
        };
        this.onPieChartClick = (item) => {
            this.onClick({ item, type: ChartClickType.CHART });
        };
        this.onPieClick = (item) => {
            this.onClick({ item, type: ChartClickType.PIE });
        };
        this.renderPieLabel = ({ cx, percent, value, x, y }) => {
            const textAnchor = x > cx ? 'start' : 'end';
            const percentageNumber = percent * 100;
            const percentageValue = `${percentageNumber.toFixed(0)}%`;
            return (React.createElement("text", { dominantBaseline: "central", fill: resolveHSLColor(this.props.labelColor), textAnchor: textAnchor, x: x, y: y }, this.props.labelValuesAsPercentage ? percentageValue : value));
        };
    }
    renderPie() {
        const { data, dataKey = PieChart_1.defaultProps.dataKey, endAngle, nameKey = PieChart_1.defaultProps.nameKey, paddingAngle, piePiecesColors = PieChart_1.defaultProps.piePiecesColors, showLabelLines, startAngle, cx = PieChart_1.defaultProps.cx, cy = PieChart_1.defaultProps.cy, } = this.props;
        const fittedCx = fitPredefinedSizeValue(cx);
        const fittedCy = fitPredefinedSizeValue(cy);
        return (React.createElement(Pie, { className: "c-chart__pie", cx: fittedCx, cy: fittedCy, data: data, dataKey: dataKey, endAngle: endAngle, label: this.renderPieLabel, labelLine: showLabelLines, nameKey: nameKey, onClick: this.onPieClick, paddingAngle: paddingAngle, startAngle: startAngle }, data.map((_entry, index) => {
            return (React.createElement(Cell, { fill: resolveHSLColor(piePiecesColors
                    ? piePiecesColors[index]
                    : PIE_PIECE_DEFAULT_COLOR), key: `c-chart-cell-${index}` }));
        })));
    }
    render() {
        const { data, dataKey, height: rawHeight, margin, minHeight, minWidth, width: rawWidth, } = this.props;
        if (!dataKey || !data.length) {
            return null;
        }
        const sizes = this.getChartSizes(rawHeight, rawWidth);
        if (!sizes.length) {
            throw new Error('[Pie Chart]: One of the props width and height must be a percentage string.');
        }
        const [height, width] = sizes;
        return (React.createElement(ResponsiveContainer, { height: height, minHeight: minHeight, minWidth: minWidth, width: width },
            React.createElement(RechartsPieChart, { className: this.getClassName(ChartType.PIE), margin: margin, onClick: this.onPieChartClick },
                this.renderPie(),
                this.renderTooltip(),
                this.renderLegends())));
    }
};
PieChart.propTypes = {
    ...BaseChart.propTypes,
    cx: predefinedSize([Unit.PX, Unit.PERCENT]),
    cy: predefinedSize([Unit.PX, Unit.PERCENT]),
    data: arrayOf(object).notEnumerable(),
    dataKey: string,
    endAngle: number,
    labelColor: color,
    labelValuesAsPercentage: bool,
    nameKey: string,
    paddingAngle: number,
    piePiecesColors: arrayOf(color),
    showLabelLines: bool,
    startAngle: number,
};
PieChart.defaultProps = {
    ...BaseChart.defaultProps,
    cx: PIE_DEFAULT_CX_VALUE,
    cy: PIE_DEFAULT_CY_VALUE,
    dataKey: '',
    endAngle: 360,
    labelColor: PIE_PIECE_DEFAULT_COLOR,
    labelValuesAsPercentage: true,
    nameKey: 'name',
    paddingAngle: 0,
    piePiecesColors: [
        'signal-cyan-45',
        'signal-green-45',
        'signal-blue-45',
        'signal-orange-45',
        'signal-pink-45',
        'signal-purple-45',
    ],
    showLabelLines: true,
    startAngle: 0,
};
PieChart = PieChart_1 = __decorate([
    AwesomeComponent({ api: PieChartAPI, type: ComponentType.DATA_DISPLAY })
], PieChart);
export { PieChart, };
//# sourceMappingURL=pie-chart.js.map